import { Address } from 'viem'
import { getImagePath } from '@/shared/lib/utils/asset.ts'
import { isLive, isStage } from '@/shared/constants/env.ts'
import { normalizeAddress } from '@/shared/lib/utils/format.ts'
import { EMPTY_ADDRESS } from '@/shared/constants/address.ts'

export const ValidatorIdMap = {
  Bughole: 'Bughole',
  StableLab: 'StableLab',
  Everstake: 'Everstake',
  Delight: 'Delight',
} as const

export type ValidatorId = keyof typeof ValidatorIdMap

export const ValidatorAddressMap: Record<ValidatorId, Address> = {
  Bughole: normalizeAddress(isLive ? '0x1856E6fDbF8FF701Fa1aB295E1bf229ABaB56899' : '0xa9c0b7A4B0B9D5af0627400850A11c5685F15B4A'),
  StableLab: normalizeAddress(isLive ? '0x9fA8A1dE3295A286b5e51dDEd41D08c417dF45A8' : EMPTY_ADDRESS),
  Everstake: normalizeAddress(isLive ? '0x1Fc1D283b357A92300c6da8dEE30b49c2ab68a03' : EMPTY_ADDRESS),
  Delight: normalizeAddress(isLive ? '0x81fee6C3022FD0B0238cb273529C814acCC02a97' : EMPTY_ADDRESS),
}

export const ValidatorIdByAddress: Record<Address, ValidatorId> = Object.fromEntries(
  Object.entries(ValidatorAddressMap).map(([key, value]) => [value, key]),
) as Record<Address, ValidatorId>

export const ValidatorDisplayNameMap: Record<ValidatorId, string> = {
  Bughole: 'BUGHOLE',
  StableLab: 'Stable Lab',
  Everstake: 'Jump Crypto - Everstake',
  Delight: 'DELIGHT',
}

export const ValidatorIconMap: Record<ValidatorId, string> = {
  Bughole: getImagePath('bughole.png', 'validator'),
  StableLab: getImagePath('stablelab.png', 'validator'),
  Everstake: getImagePath('everstake.png', 'validator'),
  Delight: getImagePath('delight.png', 'validator'),
}

export const ValidatorStakeEnableMap: Record<ValidatorId, boolean> = {
  Bughole: true,
  StableLab: isLive ? true : false,
  Everstake: isStage ? true : false,
  Delight: isLive ? true : false,
}

export const ValidatorUnstakeEnableMap: Record<ValidatorId, boolean> = {
  Bughole: true,
  StableLab: isLive ? true : false,
  Everstake: isStage ? true : false,
  Delight: isLive ? true : false,
}

export const DEFAULT_VALIDATOR_ID: ValidatorId = 'Bughole'
